const contact = document.querySelector(".container--contact");
if (contact) {
    const confirmBtn = contact.querySelector(".contact__form-btn--confirm");
    const requiredElements = contact.querySelectorAll(".require");
    function checkAllElementsFilled() {
        let allElementsFilled = true;
        requiredElements.forEach((element) => {
            if (element.value === "") {
                allElementsFilled = false;
            } else {
            }
        });
        return allElementsFilled;
    }
    requiredElements.forEach((element) => {
        element.addEventListener("change", () => {
            if (checkAllElementsFilled()) {
                confirmBtn.classList.add('contact__form-btn--confirm-active')
            } else {
                confirmBtn.classList.remove('contact__form-btn--confirm-active')
            }
        });
    });

    const submitBtn = document.querySelector('button[type="submit"]');
    if(submitBtn){
        submitBtn.onclick = () => {
            submitBtn.style.pointerEvents = "none";
            submitBtn.style.opacity = "0.6";
        }
    }
}
